import React from "react";

const StarHalf = ({ width, height, color }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 153.77994 147.24228"
		version="1.1"
		id="svg5"
		xmlns="http://www.w3.org/2000/svg">
		<defs id="defs2">
			<linearGradient
				gradientUnits="userSpaceOnUse"
				x1="20"
				y1="60"
				x2="20"
				y2="240"
				id="gradient-1"
				spreadMethod="pad"
				gradientTransform="matrix(0, 0.396078, -0.394021, 0, 104.60393, 138.916276)">
				<stop offset="0" style={{ stopOpacity: 0 }} />
				<stop offset="1" style={{ stopColor: "rgb(36, 28, 28)" }} />
			</linearGradient>
			<clipPath id="clip-0">
				<path
					id="path-2"
					style={{
						fill: "rgb(255, 255, 255)",
						stroke: "none",
						strokeWidth: 3.789,
						strokeLinecap: "round",
						strokeLinejoin: "bevel",
						strokeDasharray: "none",
						strokeDashoffset: 0,
						strokeOpacity: 1,
						paintOrder: "normal",
					}}
					d="M 35.974 195.185 C 36.208 195.234 36.442 195.26 36.673 195.26 C 44.04 195.26 52.653 169.866 58.613 165.514 C 64.573 161.16 91.258 160.774 93.535 153.73 C 95.812 146.687 74.449 130.607 72.172 123.563 C 69.896 116.519 77.776 90.889 71.816 86.535 C 65.856 82.182 44.04 97.636 36.673 97.636 C 36.454 97.636 36.218 97.621 35.974 97.595 L 35.974 195.185 Z"
				/>
			</clipPath>
		</defs>
		<g id="layer1" transform="translate(-20.298423,-67.030034)">
			<path
				style={{
					opacity: 1,
					fill: "rgb(36, 28, 28)",
					stroke: "rgb(255, 255, 255)",
					strokeWidth: 6,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeMiterlimit: 20,
					strokeDasharray: "none",
					strokeDashoffset: 0,
					strokeOpacity: 1,
					paintOrder: "normal",
				}}
				id="path2825"
				d="M 97.188 70.048 C 86.818 70.048 76.072 100.716 67.682 106.812 C 59.292 112.907 26.805 113.65 23.6 123.513 C 20.395 133.376 46.241 153.073 49.446 162.936 C 52.651 172.799 43.318 203.926 51.708 210.022 C 60.098 216.117 86.818 197.623 97.188 197.623 C 107.559 197.623 134.278 216.117 142.668 210.022 C 151.059 203.926 141.726 172.799 144.931 162.936 C 148.135 153.073 173.981 133.376 170.777 123.513 C 167.572 113.65 135.085 112.907 126.695 106.812 C 118.305 100.716 107.559 70.048 97.188 70.048 Z"
			/>
			<path
				id="path2825-3"
				style={{
					fill: color || "#ffcc00",
					stroke: "none",
					strokeWidth: 6.00009,
					strokeLinecap: "round",
					strokeLinejoin: "bevel",
					strokeDasharray: "none",
					strokeDashoffset: 0,
					strokeOpacity: 1,
					paintOrder: "normal",
				}}
				d="m 56.195501,188.89493 c 0.364653,0.0757 0.7273,0.11538 1.088301,0.11538 11.466114,0 24.869385,-39.31354 34.145666,-46.05316 9.276282,-6.73961 50.807212,-7.33845 54.350432,-18.24337 3.54323,-10.90492 -29.70398,-35.801215 -33.2472,-46.706137 -3.54323,-10.904922 8.72149,-50.587695 -0.55479,-57.327307 -9.27628,-6.739612 -43.227994,17.186981 -54.694108,17.186982 -0.342352,0 -0.707114,-0.02425 -1.088301,-0.06546 z"
				transform="matrix(-0.63153135,0,0,-0.63153135,133.3649,206.4862)"
			/>
			<path
				id="path-1"
				style={{
					stroke: "none",
					strokeWidth: 3.789,
					strokeLinecap: "round",
					strokeLinejoin: "bevel",
					strokeDasharray: "none",
					strokeDashoffset: 0,
					strokeOpacity: 1,
					paintOrder: "fill",
					fillRule: "nonzero",
					fill: "url(#gradient-1)",
					clipPath: "url(#clip-0)",
					transformBox: "fill-box",
					transformOrigin: "50% 50%",
				}}
				d="M 33.634 199.295 C 33.907 199.348 34.18 199.375 34.451 199.375 C 43.062 199.375 53.129 172.028 60.095 167.342 C 67.063 162.651 98.255 162.234 100.917 154.648 C 103.578 147.065 78.608 129.747 75.947 122.158 C 73.285 114.575 82.496 86.97 75.53 82.283 C 68.563 77.595 43.062 94.239 34.451 94.239 C 34.193 94.239 33.92 94.221 33.634 94.191 L 33.634 199.295 Z"
				transform="matrix(-1, 0, 0, -1, -0.000001, -0.000007)"
			/>
		</g>
	</svg>
);

export default StarHalf;
